import Echo from "laravel-echo"
import Pusher, { type ChannelAuthorizationCallback } from "pusher-js"
import { type XHRInstance } from "@sembark-travel/xhr"
import config from "../config"

// laravel-echo's reverb/pusher connector expects Pusher on the global.
;(window as unknown as { Pusher: typeof Pusher }).Pusher = Pusher

export type WebSocketsClient = Echo<"reverb">

// Whether the realtime (Reverb) server is configured for this environment.
export function isRealtimeEnabled(): boolean {
	return Boolean(config.services.reverb.appKey && config.services.reverb.host)
}

/**
 * Build a websockets client for the Reverb server. Channel authorization is
 * delegated to the shared axios instance so it reuses the app's Sanctum cookie,
 * XSRF header, client-version header and interceptors — there is no bearer token.
 */
export function createClient(xhr: XHRInstance): WebSocketsClient {
	return new Echo({
		broadcaster: "reverb",
		key: config.services.reverb.appKey,
		wsHost: config.services.reverb.host,
		wsPort: config.services.reverb.port,
		wssPort: config.services.reverb.port,
		forceTLS: config.services.reverb.scheme === "https",
		enabledTransports: ["ws", "wss"],
		authorizer: (channel: { name: string }) => ({
			authorize: (socketId: string, callback: ChannelAuthorizationCallback) => {
				xhr
					.post("/broadcasting/auth", {
						socket_id: socketId,
						channel_name: channel.name,
					})
					.then((resp) => callback(null, resp.data))
					.catch((error) => callback(error as Error, null))
			},
		}),
	})
}
